import NFTExperience from './nft-experience';
import NFTHelp from './nft-help';
import NFTInfo from './nft-info';
import NFTIntro from './nft-intro';
import NFTWant from './nft-want';
import NFTWithdrawal from './nft-withdrawal';

export default function NFT() {
  return (
    <div style={{ background: '#E2E6F9' }}>
      <NFTIntro />
      <NFTInfo />
      <NFTWant />
      <NFTExperience />
      <NFTHelp />
      <NFTWithdrawal />
    </div>
  );
}
